import gsap from 'gsap'
import SplitText from 'gsap/SplitText'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { q1O } from '../util/nE'
gsap.registerPlugin(SplitText, ScrollTrigger)

class RelatedPosts {
  constructor (el) {
    this.el = el
    this.title = this.el.querySelector('.related-posts__title')
    this.cards = this.el.querySelectorAll('.work-card')
  }

  init () {
    this.buildSplit()
    this.buildTimelineIn()
  }

  buildSplit () {
    if (!this.title) {
      return
    }
    this.split = new SplitText(this.title, {
      type: 'chars, words, lines',
      linesClass: 's-line u-t overflow-hidden',
      lineThreshold: 10,
    })
  }

  buildTimelineIn () {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.el,
      },
      defaults: {
        ease: (t) => {
          return q1O(t)
        },
        duration: 1,
      },
    })

    tl.set(this.el, { autoAlpha: 1 })

    if (this.title) {
      tl.fromTo(this.split.words, {
        yPercent: 100,
        autoAlpha: 0,
      }, {
        yPercent: 0,
        autoAlpha: 1,
        stagger: 0.03,
      }, 0)
    }

    ScrollTrigger.batch(this.cards, {
      once: true,
      onEnter: (batch) => {
        batch.forEach((item, index) => {
          const imageWrapper = item.querySelector('.work-card__image')
          const image = imageWrapper.querySelector('img')

          const tl = gsap.timeline({
            defaults: {
              ease: (t) => {
                return q1O(t)
              },
              duration: 2,
              delay: index * 0.1,
            },
          })

          tl.fromTo(item, {
            yPercent: 30,
            autoAlpha: 0,
          }, {
            yPercent: 0,
            autoAlpha: 1,
            ease: (t) => {
              return q1O(t)
            },
          }, 0)

          tl.to(imageWrapper, {
            clipPath: 'inset(0% round 8px)',
            ease: (t) => {
              return q1O(t)
            },
          }, 0)

          tl.to(image, {
            scale: 1,
            ease: (t) => {
              return q1O(t)
            },
          }, 0)
        })
      },
    })
  }

  destroy () {
  }
}

export default RelatedPosts



//////////////////
// WEBPACK FOOTER
// ./scripts/components/RelatedPosts.js
// module id = 65
// module chunks = 0